import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { certificates } from '../data/sbbData';
import { Award, Download, Eye, ShieldCheck, X, FileText } from 'lucide-react';
import PageHero from '../components/PageHero';

export default function CertificatesAwards() {
  const { lang, t } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [activeModalCert, setActiveModalCert] = useState(null);

  const filteredCerts = certificates.filter((c) => 
    selectedCategory === 'all' || c.category === selectedCategory
  );

  return (
    <div className="certificates-awards-page">
      {/* Page Hero */}
      <PageHero eyebrow="Kredibilitas & Standar Mutu" title={t('nav_certificates')} subtitle="Bukti komitmen Solusi Bangun Beton dalam memenuhi standar manajemen mutu (ISO), ekolabel hijau, dan keselamatan kerja (K3)." image="/reference-images/sustainability.webp" />

      {/* Breadcrumbs */}
      <div className="breadcrumb-wrapper">
        <div className="container">
          <ul className="breadcrumb-list">
            <li><Link to="/">{t('nav_home')}</Link></li>
            <li><span className="separator">/</span></li>
            <li><span className="current">{t('nav_certificates')}</span></li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <section className="section">
        <div className="container">
          {/* Category Filter Chips */}
          <div className="filter-chips">
            <button 
              className={`chip-btn ${selectedCategory === 'all' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('all')}
            >
              {t('filter_all')} Sertifikat
            </button>
            <button 
              className={`chip-btn ${selectedCategory === 'Lingkungan' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('Lingkungan')}
            >
              Lingkungan (PROPER)
            </button>
            <button 
              className={`chip-btn ${selectedCategory === 'Kualitas & Ekolabel' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('Kualitas & Ekolabel')}
            >
              Ekolabel Produk
            </button>
            <button 
              className={`chip-btn ${selectedCategory === 'Sistem Manajemen' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('Sistem Manajemen')}
            >
              ISO 9001 / 14001
            </button>
            <button 
              className={`chip-btn ${selectedCategory === 'Keselamatan Kerja (K3)' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('Keselamatan Kerja (K3)')}
            >
              ISO 45001 (K3)
            </button>
          </div>

          {/* Certificates Grid */}
          <div className="grid-3">
            {filteredCerts.map((cert) => (
              <div key={cert.id} className="sbb-card certificate-card">
                <div className="sbb-card-body">
                  <div className="cert-icon-header">
                    <Award size={32} color="var(--color-brand-primary)" />
                    <span className="sbb-card-tag">{cert.category}</span>
                  </div>

                  <h3 className="sbb-card-title">{cert.title}</h3>
                  
                  <div className="cert-meta-box">
                    <p><strong>Penerbit:</strong> {cert.issuer}</p>
                    <p><strong>No. Sertifikat:</strong> {cert.number}</p>
                    <p><strong>Masa Berlaku:</strong> {cert.year}</p>
                  </div>

                  <p className="sbb-card-desc">{cert.summary}</p>

                  <div className="cert-action-btns">
                    <button 
                      className="btn btn-outline-red btn-sm flex-grow"
                      onClick={() => setActiveModalCert(cert)}
                    >
                      <Eye size={14} />
                      <span>{t('preview_certificate')}</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certificate Modal Lightbox */}
      {activeModalCert && (
        <div className="modal-overlay" onClick={() => setActiveModalCert(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setActiveModalCert(null)}>
              <X size={20} />
            </button>

            <div className="text-center">
              <ShieldCheck size={48} color="var(--color-brand-primary)" />
              <h3 style={{ marginTop: '12px', fontSize: '22px' }}>{activeModalCert.title}</h3>
              <p style={{ color: 'var(--color-text-muted)', fontSize: '13px', marginTop: '4px' }}>
                Penerbit: {activeModalCert.issuer}
              </p>
            </div>

            <div className="modal-cert-details">
              <p><strong>Nomor Dokumen:</strong> {activeModalCert.number}</p>
              <p><strong>Status Berlaku:</strong> {activeModalCert.year}</p>
              <p><strong>Kategori:</strong> {activeModalCert.category}</p>
              <p style={{ marginTop: '12px', lineHeight: '1.6' }}>{activeModalCert.summary}</p>
            </div>

            <div className="pdf-dummy-page" style={{ margin: '20px 0' }}>
              <FileText size={32} color="var(--color-brand-primary)" style={{ margin: '0 auto 8px auto' }} />
              <p><strong>DOKUMEN RESMI TERVERIFIKASI</strong></p>
              <p>PT Solusi Bangun Beton Tbk</p>
            </div>

            <div className="text-center">
              <button 
                className="btn btn-primary"
                onClick={() => { alert(`Mengunduh dokumen PDF ${activeModalCert.title}...`); setActiveModalCert(null); }}
              >
                <Download size={16} />
                <span>{t('download_pdf')} Sertifikat</span>
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .cert-icon-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
        }

        .cert-meta-box {
          background-color: var(--color-surface-subtle);
          padding: 12px 16px;
          border-radius: var(--border-radius-sm);
          font-size: 13px;
          margin-bottom: 16px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .cert-action-btns {
          display: flex;
          gap: 8px;
          margin-top: 16px;
        }

        .modal-cert-details {
          background-color: var(--color-surface-subtle);
          padding: 20px;
          border-radius: var(--border-radius-sm);
          margin-top: 20px;
          font-size: 14px;
        }
      `}</style>
    </div>
  );
}
